import { DefaultService } from '@/services/DefaultService';
export default class CriticasDespesasService extends DefaultService {

  constructor(http, router, env) {
      super(http, router, env);
  }

  findAll(column, order, page, limit, ...params) {
    return this._http.get(encodeURI(`${this._env}/despesa/criticasdespesas.json?column=${column}&order=${order}&page=${page}&limit=${limit}&param=${params}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
  }
  findAllById(idusuario, data) {
    return this._http.get(encodeURI(`${this._env}/despesa/criticasdespesasbyid.json?idusuario=${idusuario}&checkindata=${data}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
  }

  findAllDespesasSemEmpresa(idusuario) {
    return this._http.get(`${this._env}/despesa/criticas/despesasSemEmpresa.json?idusuario=${idusuario}`, this._headers)
      .then(res => {
          return res.body;
      }, err => {
          this.verifyError(err);
          throw err;
      });
  }

  updateLocation(form) {
    return this._http.post(`${this._env}/despesa/criticasdespesas/updatecoordenada`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  corrigeEmpresa(listaIdsDespesas,idempresa) {
    return this._http.post(`${this._env}/despesa/criticasdespesas/corrigeempresa.json?idempresa=${idempresa}`, listaIdsDespesas, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }
  
  
  updateReplicaPda(idusuario, data) {
    return this._http.get(encodeURI(`${this._env}/despesa/criticasdespesas/updatepda.json?idusuario=${idusuario}&checkindata=${data}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
  }

    verificaSeExisteCritica(idusuario) {
    return this._http.get(encodeURI(`${this._env}/despesa/criticasdespesas/verifica?idusuario=${idusuario}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
  }

}